import { useSyncExternalStore } from "react";
import { Namespace, useT } from "@racoon/i18n";
import type { OrderPicksStore } from "../model/order-picks";
import { JobHeadingLinks } from "./job-heading-links";

/** The create dialog's title, followed by links to the site and customer picked so far. */
export const CreateOrderHeading = ({ picks }: { picks: OrderPicksStore }) => {
  const t = useT();
  const { location, customer } = useSyncExternalStore(picks.subscribe, picks.get);

  return (
    <div className="flex min-w-0 items-center gap-4" data-testid="create-order-heading">
      <span className="flex-shrink-0 text-base font-semibold leading-4 tracking-[-0.01em] text-text-body">
        {t(Namespace.Orders, "create.title")}
      </span>
      <JobHeadingLinks location={location} customer={customer} />
    </div>
  );
};
